import { render } from "./DualPerspective.vue?vue&type=template&id=2a2d6ab6"
import script from "./DualPerspective.vue?vue&type=script&lang=js"
export * from "./DualPerspective.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__